import { selectComponentState } from 'projectRedux/store';
import { eppTerminalAdapter } from '../adapters/eppTerminalAdapter';

export const {
  selectAll: selectAllEppTerminals,
  selectById: selectEppTerminalById,
  selectEntities: selectEppTerminalEntities,
} = eppTerminalAdapter.getSelectors((state) => selectComponentState(state).eppTerminals);
